import {useTranslator} from '../../../lib/hooks/useTranslator.js';
import {CenteredContent} from '../../CenteredContent.js';
import {Header, Icon, Modal, Segment} from 'semantic-ui-react';
import HeaderSubHeader from 'semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader.js';
import React from 'react';
import {PageRefreshButton} from '../../Buttons/PageRefreshButton.js';

export const UpdateMessage = () => {
    const [t] = useTranslator('common');

    return <CenteredContent>
        <Modal open dimmer={'inverted'}>
            <Segment placeholder padded={'very'}>
                <Header as={'h2'} icon>
                    <Icon color={'blue'} name={'gift'}/>
                    {t('errors.updateAvailableHeader')}
                    <HeaderSubHeader>
                        {t('errors.updateAvailableText')}
                    </HeaderSubHeader>
                </Header>

                <PageRefreshButton/>
            </Segment>
        </Modal>
    </CenteredContent>;
};
